module.exports = __webpack_public_path__ + "static/media/videoPlaceholder.e26a1d4b.jpg";